import React from 'react';
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { theme } from 'styled-tools';
import { formatMobileNumber } from 'utils/mobileNumberValidation';
import useConfirmMobileNumber from 'hooks/mutations/useConfirmMobileNumber/useConfirmMobileNumber';
import Button from 'components/Button';

const VerifiedIcon = styled(FontAwesomeIcon).attrs({
  icon: faCheckCircle,
})`
  margin-right: 0.2rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const MobileNumberVerificationStatus = ({
  isMobileNumberVerified,
  isMobileNumberValid,
  onSendVerificationCode,
  isLoading,
  currentValues,
  setErrorVerification,
}) => {
  const confirmMobileNumber = useConfirmMobileNumber();
  const handleVerificationClick = async () => {
    try {
      const mobileNumber = formatMobileNumber(currentValues.mobileNumber || currentValues.plainMobileNumber);
      const input = {
        mobileNumber,
      };

      if (currentValues?.id) {
        input.userId = currentValues.id;
      }
      const { data } = await confirmMobileNumber(input);

      if (data?.confirmMobileNumberExists?.mobileNumberExists) {
        setErrorVerification('Mobile Number already in system, choose a different number');
      } else {
        setErrorVerification('');
        await onSendVerificationCode();
      }
    } catch (e) {
      setErrorVerification(e.message.replace('GraphQL error: ', ''));
    }
  };

  if (isMobileNumberVerified) {
    return (
      <span style={{ marginLeft: '0.7rem' }}>
        <VerifiedIcon /> Verified
      </span>
    );
  }

  return (
    <Button
      kind={isMobileNumberValid ? 'primary' : 'tertiary'}
      onClick={handleVerificationClick}
      disabled={!isMobileNumberValid || isLoading}
      style={{ width: '100%', borderRadius: '0.25rem' }}
      type='button'
    >
      {isLoading ? 'Sending...' : 'Send Verification Code'}
    </Button>
  );

  return null;
};

export default MobileNumberVerificationStatus;
